// filepath: apps/web/src/features/admin/processes/ProcessesListRoute.tsx
//
// FR-UI-BLD-1 / ISS-f4fa1b7b-258 - staging-only-gated placeholder
// route for /admin/processes.

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { ProcessesListPage } from "./ProcessesListPage";

interface ProcessesListRouteProps {
  environmentKind: string;
}

export function ProcessesListRoute({
  environmentKind,
}: ProcessesListRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <ProcessesListPage />;
}
